<template>
  <div>
    <div class='savings-page' ref='savingsPageContainer'>
      <router-view></router-view>
      <InfoBlockSticky />
      <InfoBlock class='trigger' />
      <Footer />
    </div>
  </div>
</template>

<script>
import InfoBlock from '../components/sections/InfoBlock'
import InfoBlockSticky from '../components/sections/InfoBlockSticky'
import Footer from '../components/sections/Footer'
import { qualificationType } from '../globalVariables'
import ogImage from '../assets/images/Jornay_OG_Image.jpg'

export default {
  name: 'SavingsPage',
  metaInfo: {
    title: 'Cost & Savings Support | JORNAY PM® (methylphenidate HCI)',
    link: [
      {
        rel: 'canonical',
        href: 'https://www.jornaypm.com/savings'
      }
    ],
    meta: [
      {
        name: 'description',
        content:
          'Discover financial support resources like copay savings and insurance coverage that can help make JORNAY PM® (methylphenidate HCI) affordable for eligible patients. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:title',
        content: 'Cost & Savings Support | JORNAY PM® (methylphenidate HCI)'
      },
      {
        property: 'og:description',
        content:
          'Discover financial support resources like copay savings and insurance coverage that can help make JORNAY PM® (methylphenidate HCI) affordable for eligible patients. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:image',
        content: ogImage
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      }
    ]
  },
  components: {
    InfoBlock,
    InfoBlockSticky,
    Footer
  },
  props: {
    isQualifiedProp: {
      default: null,
      type: String || null
    }
  },
  data () {
    return {
      isQualified: null
    }
  },
  watch: {
    isQualified () {
      this.openSavings()
    },
    $route: function (newRoute) {
      if (
        newRoute.name !== 'Savings qualified' &&
        newRoute.name !== 'Savings not qualified'
      ) {
        this.isQualified = null
      }
    }
  },
  created () {
    let isQualified = sessionStorage.getItem('isQualified')

    if (isQualified != null) {
      this.isQualified = isQualified
      sessionStorage.removeItem('isQualified')
    } else {
      this.isQualified = this.isQualifiedProp
    }
    this.$root.$on('isQualifiedChange', state => {
      this.isQualified = state
      this.$scrollTo(this.$refs.savingsPageContainer)
    })
    if (this.isQualified == null) {
      this.openSavings()
    }
  },
  beforeDestroy () {
    this.$root.$off('isQualifiedChange')
  },
  methods: {
    openSavings () {
      if (this.isQualified !== null) {
        if (this.isQualified === qualificationType.PrivateInsurance) {
          this.$router.push({
            name: 'Savings qualified'
          })
        } else {
          sessionStorage.setItem('unqualifiedReason', this.isQualified)
          this.$router.push({
            name: 'Savings not qualified'
          })
        }
      } else {
        if (this.$route.name !== 'Savings') {
          this.$router.push({
            name: 'Savings'
          })
        }
      }
    }
  }
}
</script>
